import { render } from "./SettingScreen.vue?vue&type=template&id=5ca05262&scoped=true"
import script from "./SettingScreen.vue?vue&type=script&lang=js"
export * from "./SettingScreen.vue?vue&type=script&lang=js"

import "./SettingScreen.vue?vue&type=style&index=0&id=5ca05262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca05262"]])

export default __exports__